import hamburger from './hamburger.svg'
import mbeLogo from './mbe-logo.svg';
import desktopHomePageBanner from './desktop-home-page-banner.png'
import mobileHomePageBanner from './mobile-home-page-banner.png'
import samMbe from './SAMMbe.jpeg';
import vendorProfile from './vendorProfile.png';
import verifiedVendor from './verifiedVendor.png'
import acquisitionProgram from './acquisitionProgram.png';
import hubzoneCert from './hubzoneCertified.jpeg';
import mbeCert from './keyes2SafetyMBE.png';
import whyKeyes2SafetyBanner from './why-keyes-2-safety-banner.png';

export const ASSETS = {
    HAMBURGER_ICON: hamburger,
    MBE_LOGO: mbeLogo,
    DESKTOP_HOME_BANNER: desktopHomePageBanner,
    MOBILE_HOME_BANNER: mobileHomePageBanner,
    SAM_MBE: samMbe,
    VENDOR_PROFILE: vendorProfile,
    VERIFIED_VENDOR: verifiedVendor,
    ACQUISITION_PROGRAM: acquisitionProgram,
    HUBZONE_LOGO: hubzoneCert,
    MBE_CERTIFICATION: mbeCert,
    WHY_KEYES_2_SAFETY_BANNER: whyKeyes2SafetyBanner
}